import { IFilters } from '../filters.interface';

/**
 * Domain filters
 */
export class DomainFilters implements IFilters {
  public get activeFilters(): number {
    return +this.domains.length;
  }

  /**
   * Cursus filters
   *
   * @param domains Indicate which domains the results needs to be part of. Is empty if
   *                 this filter is disabled.
   */
  constructor(public domains: string[] = []) {}

  public empty(): void {
    this.domains = [];
  }

  public copy(filter: DomainFilters): void {
    this.domains = [...filter.domains];
  }
}
